var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Shape from './Shape';
import Path2D from '../geometry/Path2D';
var shapeKeys = ['pathData', 'brush'];
var Path = /** @class */ (function (_super) {
    __extends(Path, _super);
    function Path() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'path';
        _this.shapeKeys = shapeKeys;
        return _this;
    }
    Path.fromSvgPath = function (inputPath, attr) {
        return new Path(__assign(__assign({}, attr), { pathData: new Path2D(inputPath) }));
    };
    Path.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['pathData']);
    };
    Path.prototype.brush = function (ctx) {
        if (this.attr.pathData) {
            this.attr.pathData.drawOnCanvasContext(ctx);
        }
        else if (this.attr.brush) {
            this.attr.brush(ctx);
        }
    };
    Path.prototype.computeBBox = function () {
        var _a;
        return ((_a = this.attr.pathData) === null || _a === void 0 ? void 0 : _a.getPathBBox()) || { x: 0, y: 0, width: 0, height: 0 };
    };
    Path.prototype.prevProcessAttr = function (attr) {
        _super.prototype.prevProcessAttr.call(this, attr);
        this._setAttrPathData(attr);
    };
    Path.prototype._setAttrPathData = function (attr) {
        if (attr && attr.brush) {
            var path = new Path2D();
            attr.brush(path);
            attr.pathData = path;
        }
    };
    Path.prototype.pickByGPU = function () {
        return true;
    };
    return Path;
}(Shape));
export default Path;
